import httpClient from "../../api/httpClient";
import { createWrappedAsyncThunk } from "../createWrappedAsyncThunk";

export const getTopicsByTenantId = createWrappedAsyncThunk(
  "topics/getTopicsByTenantId",
  async ({ tenant_id }) => {
    const { data } = await httpClient.get(`topics`, {
      params: {
        tenant_id,
      },
    });
    return { tenant_id, data };
  }
);

export const saveTopic = createWrappedAsyncThunk(
  "topics/saveTopic",
  async (payload) => {
    return await httpClient.post(`topic`, payload);
  }
);

export const editTopic = createWrappedAsyncThunk(
  "topics/editTopic",
  async (payload) => {
    return await httpClient.put(`topic`, payload);
  }
);
